import React, { Suspense, useContext } from 'react';
import {
	Routes,
	Route,
	Link as RRLink,
	useResolvedPath,
	createPath,
} from 'react-router-dom';

import routes from './routes.json';
import { languages, language_set, DEFAULT_LANGUAGE } from './languages';
import languagedefs from './languagedefs.json';
import { Loading } from './c/Loading';
import { MeContext } from './MeContext';
import { setLanguage } from './helpers/setLanguage';
import ProductPage from "./p/ProductPage"
import NotFound from 'c/NotFound';

const components = {
	ProductPage
};

const DBRoutes = () => {
	const { me } = useContext(MeContext)
	const get_component = (r) => {
		let C = components[r.component];
		if (C === undefined)
			throw new Error(
				'component defined in routes.json but does not exist locally: ' +
				r.component +
				' for route "' +
				r.route +
				'"'
			);
		if (!me && r["loginRequired"])
			return <h1>you Did not say the magic word</h1>
		return (
			<Suspense fallback={<Loading showLoading={true} inFront />}>
				<C />
			</Suspense>
		)
	};
	let rs = [];
	for (const route of routes) {
		for (const language of languages) {
			const key = language + ':' + route.route;
			let path = '/' + language + route.route;
			if (language === DEFAULT_LANGUAGE) {
				path = '/' + route.route
			}
			rs.push(<Route key={key} path={path} element={get_component(route)} />);
			rs.push(<Route key={key+"notfound"} path={"*"} element={<NotFound />} />);
		}
	}
	return (
		<Routes>
			{rs}
		</Routes>
	)
};

const get_path_array = () => {
	// react-router-dom has `useLocation`, which ostensibly does the same
	// as `window.location`, but has these weird React-hook requirements
	// that make them unusable outside of components, so here's some really
	// old fashioned JS for you!
	return window.location.pathname.split('/').slice(1);
};

const get_current_language = () => {
	const lang = setLanguage();
	return lang;
};

const get_current_language_def = () => languagedefs.find(la => la.lang === get_current_language())

const LL = (path) => {
	let newPath = path
	const try_lang = window.location.pathname.split('/').slice(1)[0].toLowerCase();
	if (language_set[try_lang]) {
		newPath = '/' + get_current_language() + path;
	}
	return newPath
}

const Link = (props) => {
	const path = LL(createPath(useResolvedPath(props.to)));
	const pprops = { ...props, to: undefined, children: undefined };
	return (
		<RRLink {...pprops} to={path}>
			{props.children}
		</RRLink>
	);
};

const goto_language = (lang) => {
	if (lang === get_current_language()) return;
	let xs = get_path_array();
	xs[0] = lang;
	window.location.pathname = xs.join('/');
};

export { DBRoutes, Link, LL, get_current_language, goto_language, get_current_language_def };
